<template>

    <div class="px-2 py-2 flex flex-row">
        <div>
            <button class="text-white font-bold py-3 px-3 rounded rounded-r-none" :class="{'bg-blue-darker': linkType == 'RTMP', 'bg-blue': linkType == 'HLS'}" v-on:click="toggleType('RTMP')">
                RTMP
            </button>
            <button class="text-white font-bold py-3 px-3 rounded rounded-l-none" :class="{'bg-blue-darker': linkType == 'HLS', 'bg-blue': linkType == 'RTMP'}" v-on:click="toggleType('HLS')">
                HLS
            </button>
        </div>
        <div class="flex-grow pl-5">
            <input class="border w-full p-3 outline-none focus:border-blue-dark rounded" type="text" v-model="linkUrl" />
        </div>
    </div>

</template>

<script>

    import * as Config from '@/config'

	export default {
		name: 'StreamUrl-Comp',
		data () {
			return {
                linkType: "RTMP",
                linkUrl: "rtmp://rtmp.edge-media.livestormchasing.com/live/" + this.streamId,
            }
        },
        props: [
            'streamId',
        ],
		mounted() {
		},
		methods: {
            toggleType(link) {
                this.linkType = link;
                if(link == "RTMP") {
                    this.linkUrl = "rtmp://rtmp.edge-media.livestormchasing.com/live/" + this.streamId;
                } else {
                    // link is hls
                    this.linkUrl = "https://edge-media.livestormchasing.com/hls/" + this.streamId + "/index.m3u8";
                }
            }
		},
	}
</script>

<style>
	#videoHolder {
		width: 100%;
		height: 100%;
	}

    .video {
        width: 100%;
        height: 100%;
    }
</style>
